import React from "react";
import "./Game_Statistics_cards.css";

function Game_Statistics_cards({ name, totalLotteryBet, numberOfBets, winningAmount }) {
  return (
    <>
      <section className="Game_Statistics_cards">
        <div className="Betting_Rebate_history_card">
          <div className="history_card">

            <div className="history_header">
              <div className="heading_icon_img_holder">
                <img
                  src="/assets/images/game_statistics/ball.png"
                  className="icon_img"
                  alt="img icon"
                />
              </div>
              <span>{name}</span>
            </div>

            <div className="timeline">

              <div className="timeline_item">
                <div className="timeline_left">
                  <span className="circle"></span>
                </div>

                <div className="timeline_content">
                  <span>Total bet</span>
                  <span>{totalLotteryBet}</span>
                </div>
              </div>

              <div className="timeline_item">
                <div className="timeline_left">
                  <span className="circle"></span>
                </div>

                <div className="timeline_content">
                  <span>Numbers of bets</span>
                  <span>{numberOfBets}</span>
                </div>
              </div>

              <div className="timeline_item">
                <div className="timeline_left">
                  <span className="circle"></span>
                </div>

                <div className="timeline_content">
                  <span>Winning Amount</span>
                  <span className="red">{winningAmount}</span>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default Game_Statistics_cards;